import PropTypes from "prop-types";
import cn from "classnames";
import { Button } from "@components/button";
import { BinocularsFeature } from "@icons";

export function Banner({ className = "", subheading = "", heading, cta }) {
  return (
    <section className={cn("bg-itinerary-blue-50 py-20", className)}>
      <div className="container text-center">
        <BinocularsFeature className="w-16 h-16 mx-auto" />

        <div className="my-10">
          <h3 className="font-mencken text-2xl md:text-3xl">{heading}</h3>
          <p className="mt-6 md:text-xl">{subheading}</p>
        </div>

        <Button
          className="btn btn-primary"
          onClick={cta.onClick}
          href={cta.href}
        >
          {cta.label}
        </Button>
      </div>
    </section>
  );
}

Banner.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  cta: PropTypes.shape({
    href: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
};
